// Kirjala: ostoskorin sivupaneelin automaattiset tuotesuositukset + lahjaportaat (myös lisäysilmoitukseen) + Tyhjennä ostoskori -painike.
// 4.11.: samat toiminnot myös ostoskorisivulla (/cart): lahjaportaat + ilmainen toimitus samassa laatikossa,
// tuplaus, valintalista, suositukset ja Tyhjennä ostoskori. Sivulla laatikko on oikean palstan yläosassa (.cart__blocks).
// Näytetään paneelin alareunassa kiinteänä (kokonaishinnan ja Kassa-painikkeen yläpuolella),
// sivuttain rullattavana rivinä. Suositusten HTML tulee osiosta sections/kirjala-cart-recs.liquid.
//
// Lahjaportaat (alennukset: Shopify > Alennukset, automaattiset "Kaupan päälle: ..."):
//  - 99 €: Paahtajan yllätyskahvi 150 g lisätään koriin automaattisesti (ja poistetaan, jos summa laskee alle rajan).
//  - 139 €: ilmainen 250 g kahvipussi perusvalikoimasta (BASIC_COFFEES). Jos korissa on perusvalikoiman kahvia,
//    korissa näkyy tuplauspainike (sama kahvi ja jauhatus 250 g:na, myös 500 g / 1 kg -pakkauksista). Muuten valintalista.
//  Summa lasketaan alennusten jälkeen ilman lahjoja (lahjatuote ja ilmaiseksi alennettu 250 g -pussi).
(function () {
  if (window.KirjalaCartRecsLoaded) return;
  window.KirjalaCartRecsLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};
  var timer = null;

  var GIFT_VARIANT_ID = 57774526497094; // Paahtajan yllätyskahvi 150 g (piilotettu tuote)
  var TIER1 = 9900; // senttiä, kaupan valuutassa (EUR)
  var TIER2 = 13900;
  var giftBusy = false;
  var giftFailed = false;
  var lastCartSig = '';

  // Ostoskorisivu (sections/main-cart-items + main-cart-footer). Sivulla sivupaneelia ei käsitellä.
  function onPage() {
    return !!(document.getElementById('main-cart-footer') && document.getElementById('main-cart-items'));
  }

  function sectionIds() {
    if (onPage()) {
      return [document.getElementById('main-cart-items').dataset.id, document.getElementById('main-cart-footer').dataset.id, 'cart-icon-bubble'];
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function sectionInner(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  // Piirtää ostoskorisivun uudelleen cart/add.js- tai change.js-vastauksen osioista (kuten teeman cart.js).
  function renderPage(sections, itemCount) {
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (!sections || !items || !footer) return false;
    var map = [[items, items.dataset.id], [footer, footer.dataset.id]];
    for (var i = 0; i < map.length; i++) {
      var html = sections[map[i][1]];
      var target = map[i][0].querySelector('.js-contents');
      if (!html || !target) return false;
      var inner = sectionInner(html, '.js-contents');
      if (inner === null) return false;
      target.innerHTML = inner;
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var b = sectionInner(sections['cart-icon-bubble'], '.shopify-section');
      if (b !== null) bubble.innerHTML = b;
    }
    if (typeof itemCount === 'number') {
      var empty = itemCount === 0;
      var ci = document.querySelector('cart-items');
      if (ci) ci.classList.toggle('is-empty', empty);
      footer.classList.toggle('is-empty', empty);
      if (empty) window.location.reload(); // tyhjä kori: teeman oma tyhjän korin näkymä
    }
    return true;
  }

  // 139 €:n ilmainen 250 g pussi: vain perusvalikoiman kahvit (vaaleanpunaiset brändipussit).
  // Pidä sama lista kuin alennuksessa "Kaupan päälle: yllätyskahvi 150 g + valitsemasi 250 g kahvi".
  var BASIC_COFFEES = [
    ['vipunen-etiopialainen-vaaleapaahtoinen-kahvi', 'Vipunen'],
    ['halo-beriti-etiopialainen-vaaleapaahtoinen-kahvi', 'Halo Beriti'],
    ['aino-kolumbialainen-vaaleapaahtoinen-kahvi', 'Aino'],
    ['kalervo-brasilialainen-keskipaahtoinen-kahvi', 'Kalervo'],
    ['pellervo-brasilialainen-keskipaahtoinen-kahvi', 'Pellervo'],
    ['louhi-etiopialainen-keskipaahtoinen-kahvi', 'Louhi'],
    ['jukola-etiopialainen-tummapaahtoinen-kahvi', 'Jukola'],
    ['sammon-perulainen-tummapaahtoinen-kahvi', 'Sammon'],
    ['otava-tositummapaahtoinen-kahvi', 'Otava'],
    ['sariola-vaaleapaahtoinen-kofeiiniton-kahvi', 'Sariola vaalea'],
    ['sariola-tummapaahtoinen-kofeiiniton-kahvi', 'Sariola tumma'],
  ];

  var lang = (document.documentElement.lang || 'fi').slice(0, 2).toLowerCase();
  var T = {
    fi: {
      ship: 'Lisää vielä {x}, niin saat ilmaisen toimituksen!',
      shipDone: 'Ilmainen toimitus ✓',
      t1: 'Tilaa vielä {x}, niin saat kaupan päälle Paahtajan yllätyskahvin 150 g!',
      t2: 'Yllätyskahvi 150 g lisätty kaupan päälle! Tilaa vielä {x}, niin saat myös ilmaisen 250 g kahvin.',
      t3: 'Saat ilmaisen 250 g kahvin perusvalikoimastamme!',
      pick: 'Valitse kahvi',
      t3double: 'Saat ilmaisen 250 g kahvin! Tuplaa korisi kahvi:',
      doubleAria: 'Lisää ilmaiseksi',
      t4: 'Molemmat lahjat ansaittu. Kiitos!',
      clear: 'Tyhjennä ostoskori',
      clearConfirm: 'Vahvista tyhjennys',
      toast1: 'Lisää vielä {x}, niin saat kaupan päälle Paahtajan yllätyskahvin 150 g!',
      toast2: 'Lisää vielä {x}, niin saat myös vapaavalintaisen 250 g kahvipussin!',
      toast1done: 'Paahtajan yllätyskahvi 150 g tulee kaupan päälle!',
      toast2done: 'Saat 250 g kahvipussin kaupan päälle! Valitse se ostoskorissa.',
    },
    en: {
      ship: 'Add {x} more to get free shipping!',
      shipDone: 'Free shipping ✓',
      t1: 'Spend {x} more to get the Roaster’s surprise coffee 150 g for free!',
      t2: 'Surprise coffee 150 g added for free! Spend {x} more to also get a free 250 g coffee.',
      t3: 'You get a free 250 g coffee from our core range!',
      pick: 'Choose coffee',
      t3double: 'You get a free 250 g coffee! Double a coffee in your cart:',
      doubleAria: 'Add for free',
      t4: 'Both gifts unlocked. Thank you!',
      clear: 'Empty cart',
      clearConfirm: 'Confirm: empty cart',
      toast1: 'Add {x} more to get the Roaster’s surprise coffee 150 g for free!',
      toast2: 'Add {x} more to also get a free 250 g bag of coffee of your choice!',
      toast1done: 'The Roaster’s surprise coffee 150 g is on us!',
      toast2done: 'You get a free 250 g bag of coffee! Choose it in your cart.',
    },
    sv: {
      ship: 'Handla för {x} till för att få fri frakt!',
      shipDone: 'Fri frakt ✓',
      t1: 'Handla för {x} till så får du rostarens överraskningskaffe 150 g på köpet!',
      t2: 'Överraskningskaffe 150 g tillagt på köpet! Handla för {x} till så får du även ett gratis 250 g kaffe.',
      t3: 'Du får ett gratis 250 g kaffe från vårt basutbud!',
      pick: 'Välj kaffe',
      t3double: 'Du får ett gratis 250 g kaffe! Dubbla ett kaffe i varukorgen:',
      doubleAria: 'Lägg till gratis',
      t4: 'Båda presenterna upplåsta. Tack!',
      clear: 'Töm varukorgen',
      clearConfirm: 'Bekräfta: töm varukorgen',
      toast1: 'Handla för {x} till så får du rostarens överraskningskaffe 150 g på köpet!',
      toast2: 'Handla för {x} till så får du även en valfri 250 g kaffepåse på köpet!',
      toast1done: 'Rostarens överraskningskaffe 150 g ingår på köpet!',
      toast2done: 'Du får en 250 g kaffepåse på köpet! Välj den i varukorgen.',
    },
  };
  var tx = T[lang] || T.fi;

  function rate() {
    var r = window.Shopify && window.Shopify.currency && parseFloat(window.Shopify.currency.rate);
    return r && r > 0 ? r : 1;
  }

  function money(cents, currency) {
    // Sama muoto kuin kaupan hinnoissa (esim. €10,90)
    if (!currency || currency === 'EUR') return '€' + (cents / 100).toFixed(2).replace('.', ',');
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fi', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function isGiftLine(item) {
    return item.variant_id === GIFT_VARIANT_ID;
  }

  function isFreeLine(item) {
    // 250 g lahjapussi: rivi on alennettu kokonaan ilmaiseksi
    return item.original_line_price > 0 && item.final_line_price === 0;
  }

  function cartInfo(cart) {
    var total = 0;
    var giftLine = null;
    var freeClaimed = false;
    (cart.items || []).forEach(function (item) {
      if (isGiftLine(item)) {
        giftLine = item;
        return;
      }
      if (isFreeLine(item)) {
        freeClaimed = true;
        return;
      }
      total += item.final_line_price;
    });
    return { total: total, giftLine: giftLine, freeClaimed: freeClaimed };
  }

  function renderState(state, variantId, silent) {
    var drawer = document.querySelector('cart-drawer');
    if (!state || state.status || !state.sections) return false;
    if (onPage()) {
      var count = typeof state.item_count === 'number' ? state.item_count : undefined;
      return renderPage(state.sections, count);
    }
    state.id = variantId;
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state, silent ? { silent: true } : {});
      return true;
    }
    return false;
  }

  function changeLine(key, quantity) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: sectionIds(),
        sections_url: window.location.pathname,
      }),
    }).then(function (r) { return r.json(); });
  }

  function addGift() {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: GIFT_VARIANT_ID, quantity: 1 }],
        sections: sectionIds(),
        sections_url: window.location.pathname,
      }),
    }).then(function (r) { return r.json(); });
  }

  // Lisää / poistaa yllätyskahvin ja pitää sen määrän yhdessä. Palauttaa true, jos korin sisältö muuttui.
  function syncGift(cart, info) {
    if (giftBusy) return Promise.resolve(true);
    if (giftFailed) return Promise.resolve(false);
    var t1 = Math.round(TIER1 * rate());
    var action = null;
    if (info.total >= t1 && !info.giftLine) action = addGift;
    else if (info.total < t1 && info.giftLine) action = function () { return changeLine(info.giftLine.key, 0); };
    else if (info.giftLine && info.giftLine.quantity > 1) action = function () { return changeLine(info.giftLine.key, 1); };
    if (!action) return Promise.resolve(false);
    giftBusy = true;
    return action()
      .then(function (state) {
        giftBusy = false;
        if (!state || state.status || !state.sections) {
          giftFailed = true; // esim. tuote ei saatavilla tällä markkinalla, ei yritetä uudelleen
          return false;
        }
        // Jos paneeli on kiinni (tuote lisättiin tuotesivulta), ei avata paneelia vaan päivitetään lisäysilmoitus.
        var d = document.querySelector('cart-drawer');
        var silent = !(d && d.classList.contains('active'));
        if (!renderState(state, GIFT_VARIANT_ID, silent)) window.location.reload();
        return true;
      })
      .catch(function () {
        giftBusy = false;
        return false;
      });
  }

  // Tuplaus: korissa olevat perusvalikoiman kahvit (tuote + jauhatus), joista voi lisätä ilmaisen 250 g pussin.
  function escapeAttr(v) {
    return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  function grindOf(item) {
    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) {
      if (!/^\s*\d+([.,]\d+)?\s*(g|kg)\s*$/i.test(opts[i].value)) return opts[i].value;
    }
    return '';
  }

  function doubleCandidates(cart) {
    var seen = {};
    var out = [];
    (cart.items || []).forEach(function (item) {
      if (isGiftLine(item) || isFreeLine(item)) return;
      var basic = null;
      for (var i = 0; i < BASIC_COFFEES.length; i++) {
        if (BASIC_COFFEES[i][0] === item.handle) basic = BASIC_COFFEES[i];
      }
      if (!basic) return;
      var grind = grindOf(item);
      var key = item.handle + '|' + grind;
      if (seen[key]) return;
      seen[key] = true;
      out.push({ handle: item.handle, name: basic[1], grind: grind });
    });
    return out.slice(0, 4);
  }

  // Etsii tuotteesta saman jauhatuksen 250 g -variantin (varalla mikä tahansa saatavilla oleva 250 g).
  function find250(handle, grind) {
    return fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var is250 = function (v) {
          return (v.options || [v.option1, v.option2, v.option3]).some(function (o) { return /^\s*250\s*g\s*$/i.test(o || ''); });
        };
        var hasGrind = function (v) {
          return (v.options || [v.option1, v.option2, v.option3]).indexOf(grind) !== -1;
        };
        var vs = (p.variants || []).filter(function (v) { return v.available && is250(v); });
        var exact = vs.filter(hasGrind)[0];
        return exact || vs[0] || null;
      });
  }

  function addDouble(button) {
    button.setAttribute('aria-busy', 'true');
    find250(button.getAttribute('data-handle'), button.getAttribute('data-grind'))
      .then(function (variant) {
        if (!variant) throw new Error('no 250 g');
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variant.id, quantity: 1 }],
            sections: sectionIds(),
            sections_url: window.location.pathname,
          }),
        })
          .then(function (r) { return r.json(); })
          .then(function (state) {
            if (state.status || !state.sections) throw new Error('add failed');
            if (!renderState(state, variant.id)) window.location.reload();
          });
      })
      .catch(function () {
        button.removeAttribute('aria-busy');
      });
  }

  function tierMessage(cart, info) {
    var r = rate();
    var t1 = Math.round(TIER1 * r);
    var t2 = Math.round(TIER2 * r);
    var cur = cart.currency;
    var html = '';
    var pct;
    // Ilmainen toimitus samaan laatikkoon: raja luetaan piilotetusta free-shipping-bar-elementistä (markkinakohtainen).
    var shipEl = document.querySelector((onPage() ? '#main-cart-footer' : 'cart-drawer') + ' .free-shipping-bar[data-threshold]') ||
      document.querySelector('.free-shipping-bar[data-threshold]');
    var ship = shipEl ? parseInt(shipEl.getAttribute('data-threshold'), 10) || 0 : 0;
    if (ship && cart.total_price < ship) {
      html = tx.ship.replace('{x}', '<strong>' + money(ship - cart.total_price, cur) + '</strong>');
      pct = (info.total / t2) * 100;
    } else if (info.total < t1) {
      html = (ship ? '<span class="kirjala-gift-tiers__ok">' + tx.shipDone + '</span> ' : '') +
        tx.t1.replace('{x}', '<strong>' + money(t1 - info.total, cur) + '</strong>');
      pct = (info.total / t2) * 100;
    } else if (info.total < t2) {
      html = tx.t2.replace('{x}', '<strong>' + money(t2 - info.total, cur) + '</strong>');
      pct = (info.total / t2) * 100;
    } else if (!info.freeClaimed && doubleCandidates(cart).length) {
      html = tx.t3double + ' ' + doubleCandidates(cart).map(function (c) {
        return '<button type="button" class="kirjala-gift-double" data-kcr-double data-handle="' + c.handle + '" data-grind="' + escapeAttr(c.grind) + '" aria-label="' + escapeAttr(tx.doubleAria + ': ' + c.name + ' 250 g, ' + c.grind) + '">' +
          '+ ' + c.name + ' 250 g' + (c.grind ? ', ' + c.grind : '') + '</button>';
      }).join(' ');
      pct = 100;
    } else if (!info.freeClaimed) {
      html = tx.t3 + ' <details class="kirjala-gift-pick"><summary>' + tx.pick + '</summary><span class="kirjala-gift-pick__list">' +
        BASIC_COFFEES.map(function (c) {
          return '<a href="' + root + 'products/' + c[0] + '">' + c[1] + '</a>';
        }).join(' · ') + '</span></details>';
      pct = 100;
    } else {
      html = tx.t4;
      pct = 100;
    }
    var marks = [t1];
    if (ship && ship < t2) marks.unshift(ship);
    var ticks = marks.map(function (m) {
      var done = (m === ship ? cart.total_price : info.total) >= m;
      return '<i' + (done ? ' class="is-done"' : '') + ' style="left:' + Math.round((m / t2) * 100) + '%"></i>';
    }).join('');
    return (
      '<div class="kirjala-gift-tiers__text">' + html + '</div>' +
      '<div class="kirjala-gift-tiers__bar" aria-hidden="true"><span style="width:' + Math.min(100, Math.max(0, pct)).toFixed(1) + '%"></span>' +
      ticks + '</div>'
    );
  }

  function ensureStyle() {
    if (document.getElementById('kirjala-gift-tiers-style')) return;
    var st = document.createElement('style');
    st.id = 'kirjala-gift-tiers-style';
    st.textContent =
      '.kirjala-gift-tiers{margin:0 0 1rem;padding:0.8rem 1rem;border-radius:var(--inputs-radius,6px);background:rgba(var(--color-button),0.08);font-size:1.3rem;line-height:1.4}' +
      '.kirjala-gift-tiers__text{margin:0 0 0.6rem}' +
      '.kirjala-gift-tiers__text a{color:rgb(var(--color-button));font-weight:600}' +
      '.kirjala-gift-tiers__ok{font-weight:600;color:rgb(var(--color-button))}' +
      '.kirjala-gift-pick{display:inline}' +
      '.kirjala-gift-pick summary{display:inline;list-style:none;cursor:pointer;color:rgb(var(--color-button));font-weight:600;text-decoration:underline;text-underline-offset:0.2rem}' +
      '.kirjala-gift-pick summary::-webkit-details-marker{display:none}' +
      '.kirjala-gift-pick summary::after{content:" \\25BE"}' +
      '.kirjala-gift-pick[open] summary::after{content:" \\25B4"}' +
      '.kirjala-gift-pick__list{display:block;margin-top:0.3rem}' +
      '.kirjala-gift-double{display:inline-block;margin:0.4rem 0.4rem 0 0;padding:0.3rem 1rem;border:1px solid rgb(var(--color-button));border-radius:2rem;background:rgb(var(--color-background));color:rgb(var(--color-button));font:inherit;font-weight:600;line-height:1.3;cursor:pointer}' +
      '.kirjala-gift-double:hover{background:rgb(var(--color-button));color:rgb(var(--color-button-text))}' +
      '.kirjala-gift-double[aria-busy=true]{opacity:0.5;pointer-events:none}' +
      '.kirjala-gift-tiers__bar{position:relative;height:0.6rem;border-radius:1rem;background:rgba(var(--color-foreground),0.1);overflow:visible}' +
      '.kirjala-gift-tiers__bar span{display:block;height:100%;border-radius:1rem;background:rgb(var(--color-button));transition:width .3s ease}' +
      '.kirjala-gift-tiers__bar i{position:absolute;top:-0.2rem;width:0.2rem;height:1rem;background:rgba(var(--color-foreground),0.35)}' +
      '.kirjala-clear-cart{display:flex;justify-content:flex-end;margin:0.2rem 0 0.8rem}' +
      '.kirjala-clear-cart button{display:inline-flex;align-items:center;gap:0.4rem;padding:0.6rem 0;border:0;background:none;color:rgba(var(--color-foreground),0.75);font:inherit;font-size:1.25rem;text-decoration:underline;text-underline-offset:0.3rem;cursor:pointer}' +
      '.kirjala-clear-cart button:hover{color:rgb(var(--color-foreground))}' +
      '.kirjala-clear-cart button[data-confirm]{color:rgb(var(--color-button));font-weight:600}' +
      '.kirjala-clear-cart button[aria-busy=true]{opacity:0.5;pointer-events:none}' +
      // Ostoskorisivu: ilmaisen toimituksen palkki piiloon (näkyy lahjalaatikossa), laatikko ja suositukset oikean palstan yläosaan.
      '#main-cart-footer .free-shipping-bar{display:none}' +
      '#main-cart-footer .kirjala-gift-tiers{margin:0 0 1.6rem;padding:1.2rem 1.4rem;font-size:1.4rem}' +
      '#main-cart-footer .kirjala-gift-tiers__bar i.is-done{background:rgb(var(--color-button))}' +
      '#main-cart-footer .kirjala-cart-recs-host{max-width:100%;overflow:hidden}' +
      '#main-cart-footer .kirjala-cart-recs-host:empty{display:none}' +
      '#main-cart-items .kirjala-clear-cart{margin:0.4rem 0 0}' +
      '#main-cart-items .kirjala-clear-cart button{font-size:1.3rem}' +
      'cart-items.is-empty .kirjala-clear-cart{display:none}';
    document.head.appendChild(st);
  }

  function updateTiers(footer, cart, info) {
    ensureStyle();
    var box = footer.querySelector('.kirjala-gift-tiers');
    if (!box) {
      box = document.createElement('div');
      box.className = 'kirjala-gift-tiers';
      box.setAttribute('role', 'status');
      footer.insertAdjacentElement('afterbegin', box);
    }
    var html = tierMessage(cart, info);
    if (box.getAttribute('data-html') !== html) {
      box.innerHTML = html;
      box.setAttribute('data-html', html);
    }
  }

  // Lisäysilmoitus (#CartToast, assets/cart-drawer.js): lisätään ilmaisen toimituksen rivin alle lahjaportaiden rivit.
  function toastGiftLines(cart) {
    var info = cartInfo(cart);
    var r = rate();
    var t1 = Math.round(TIER1 * r);
    var cur = cart.currency;
    var lines = [];
    // Väinö 3.11.: ilmoituksessa vain yllätyskahvi; 250 g lahjasta kerrotaan vasta ostoskorissa (ei liian tyrkyllä).
    if (info.total < t1) {
      lines.push(tx.toast1.replace('{x}', '<strong>' + money(t1 - info.total, cur) + '</strong>'));
    } else {
      lines.push('🎁 ' + tx.toast1done);
    }
    return lines;
  }

  var toastReq = 0;
  function decorateToast(toast) {
    if (!toast || toast.querySelector('.cart-toast__gift') || !toast.querySelector('.cart-toast__title')) return;
    var req = ++toastReq;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (req !== toastReq || toast.querySelector('.cart-toast__gift')) return;
        if (!cart.items || !cart.items.length) return;
        var before = toast.querySelector('.cart-toast__view');
        toastGiftLines(cart).forEach(function (html) {
          var p = document.createElement('p');
          p.className = 'cart-toast__shipping cart-toast__gift';
          p.innerHTML = html;
          toast.insertBefore(p, before || null);
        });
      })
      .catch(function () {});
  }

  function watchToast() {
    var observed = null;
    var toastObserver = new MutationObserver(function () {
      decorateToast(observed);
    });
    function attach() {
      var toast = document.getElementById('CartToast');
      if (!toast || toast === observed) return;
      observed = toast;
      toastObserver.disconnect();
      toastObserver.observe(toast, { childList: true });
      decorateToast(toast);
    }
    new MutationObserver(attach).observe(document.body, { childList: true });
    attach();
  }

  // Tyhjennä ostoskori -painike tuotelistan loppuun. Ensimmäinen napautus pyytää vahvistuksen, toinen tyhjentää.
  function ensureClearButton(drawer) {
    var wrapper = onPage() ? document.getElementById('main-cart-items') : drawer.querySelector('.drawer__cart-items-wrapper');
    if (!wrapper || wrapper.querySelector('.kirjala-clear-cart')) return;
    ensureStyle();
    var box = document.createElement('div');
    box.className = 'kirjala-clear-cart';
    box.innerHTML = '<button type="button" data-kcr-clear>' + tx.clear + '</button>';
    wrapper.appendChild(box);
  }

  var clearTimer = null;
  function clearCart(button) {
    if (!button.hasAttribute('data-confirm')) {
      button.setAttribute('data-confirm', '');
      button.textContent = tx.clearConfirm;
      clearTimeout(clearTimer);
      clearTimer = setTimeout(function () {
        button.removeAttribute('data-confirm');
        button.textContent = tx.clear;
      }, 4000);
      return;
    }
    clearTimeout(clearTimer);
    button.setAttribute('aria-busy', 'true');
    var drawer = document.querySelector('cart-drawer');
    fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function () {
        if (onPage()) {
          window.location.reload(); // teeman oma tyhjän korin näkymä
          return new Promise(function () {});
        }
        return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); });
      })
      .then(function (sections) {
        cache = {};
        lastCartSig = '';
        if (drawer) drawer.classList.add('is-empty');
        var items = document.querySelector('cart-drawer-items');
        if (items) items.classList.add('is-empty');
        if (!renderState({ sections: sections }, null)) window.location.reload();
        document.dispatchEvent(new CustomEvent('kirjala:cart-cleared'));
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function ensure() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var footer = drawer.querySelector('.drawer__footer');
    if (!footer) return;
    var hasItems = !!drawer.querySelector('.drawer__cart-items-wrapper');
    var el = footer.querySelector('.kirjala-cart-recs-host');
    var tiers = footer.querySelector('.kirjala-gift-tiers');
    if (!hasItems) {
      if (el) el.remove();
      if (tiers) tiers.remove();
      return;
    }

    ensureClearButton(drawer);

    var needRecs = !el;
    if (needRecs) {
      el = document.createElement('div');
      el.className = 'kirjala-cart-recs-host';
      footer.insertAdjacentElement('afterbegin', el);
    }
    var host = el;

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var info = cartInfo(cart);
        var sig = cart.token + '|' + cart.item_count + '|' + cart.total_price + '|' + (footer.querySelector('.kirjala-gift-tiers') ? 1 : 0);
        return syncGift(cart, info).then(function (changed) {
          if (changed) return null; // kori piirretään uudelleen ja ensure ajetaan uudestaan
          if (sig !== lastCartSig || !footer.querySelector('.kirjala-gift-tiers')) {
            lastCartSig = sig;
            updateTiers(footer, cart, info);
          }
          if (!needRecs) return null;
          var items = (cart.items || []).filter(function (i) { return !isGiftLine(i); });
          if (!items.length) return '';
          var productId = items[0].product_id;
          var key = productId + '|' + items.map(function (i) { return i.product_id; }).join(',');
          if (cache[key] !== undefined) return cache[key];
          return fetch(root + 'recommendations/products?section_id=kirjala-cart-recs&limit=10&intent=related&product_id=' + productId)
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (text) {
              var doc = new DOMParser().parseFromString(text, 'text/html');
              var recs = doc.querySelector('.kirjala-cart-recs');
              cache[key] = recs ? recs.outerHTML : '';
              return cache[key];
            });
        });
      })
      .then(function (html) {
        if (html === null) return;
        if (host.isConnected) host.innerHTML = html || '';
      })
      .catch(function () {});
  }

  // Ostoskorisivu: sama logiikka kuin sivupaneelissa. Laatikko ja suositukset .cart__blocks-alueen alkuun
  // (teeman cart.js korvaa vain .js-contents-osat, joten nämä säilyvät määrämuutoksissa).
  function ensurePage() {
    var blocks = document.querySelector('#main-cart-footer .cart__blocks');
    if (!blocks) return;
    ensureStyle();
    ensureClearButton(null);
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = blocks.querySelector('.kirjala-cart-recs-host');
        if (!cart.items || !cart.items.length) {
          if (el) el.remove();
          var t = blocks.querySelector('.kirjala-gift-tiers');
          if (t) t.remove();
          return null;
        }
        var info = cartInfo(cart);
        return syncGift(cart, info).then(function (changed) {
          if (changed) return null;
          var needRecs = !el;
          if (needRecs) {
            el = document.createElement('div');
            el.className = 'kirjala-cart-recs-host';
            blocks.insertAdjacentElement('afterbegin', el);
          }
          var sig = cart.token + '|' + cart.item_count + '|' + cart.total_price + '|page';
          if (sig !== lastCartSig || !blocks.querySelector('.kirjala-gift-tiers')) {
            lastCartSig = sig;
            updateTiers(blocks, cart, info);
          }
          var items = cart.items.filter(function (i) { return !isGiftLine(i); });
          if (!items.length) return null;
          var productId = items[0].product_id;
          var key = productId + '|' + items.map(function (i) { return i.product_id; }).join(',');
          if (!needRecs && el.getAttribute('data-key') === key) return null;
          el.setAttribute('data-key', key);
          var host = el;
          var p = cache[key] !== undefined ? Promise.resolve(cache[key]) :
            fetch(root + 'recommendations/products?section_id=kirjala-cart-recs&limit=10&intent=related&product_id=' + productId)
              .then(function (r) { return r.ok ? r.text() : ''; })
              .then(function (text) {
                var doc = new DOMParser().parseFromString(text, 'text/html');
                var recs = doc.querySelector('.kirjala-cart-recs');
                cache[key] = recs ? recs.outerHTML : '';
                return cache[key];
              });
          return p.then(function (html) {
            if (host.isConnected) host.innerHTML = html || '';
            return null;
          });
        });
      })
      .catch(function () {});
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(onPage() ? ensurePage : ensure, 80);
  }

  function addToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    button.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: sectionIds(),
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status || !state.sections) {
          button.removeAttribute('aria-busy');
          return;
        }
        if (!renderState(state, variantId)) window.location.reload();
      })
      .catch(function () {
        button.removeAttribute('aria-busy');
      });
  }

  function scrollList(button) {
    var wrap = button.closest('.kirjala-cart-recs');
    var list = wrap && wrap.querySelector('.kirjala-cart-recs__list');
    if (!list) return;
    var dir = Number(button.getAttribute('data-kcr-scroll')) || 1;
    list.scrollBy({ left: dir * list.clientWidth * 0.8, behavior: 'smooth' });
  }

  function onClick(event) {
    var arrow = event.target.closest('[data-kcr-scroll]');
    if (arrow) {
      event.preventDefault();
      scrollList(arrow);
      return;
    }
    var doubleBtn = event.target.closest('[data-kcr-double]');
    if (doubleBtn) {
      event.preventDefault();
      addDouble(doubleBtn);
      return;
    }
    var clearBtn = event.target.closest('[data-kcr-clear]');
    if (clearBtn) {
      event.preventDefault();
      clearCart(clearBtn);
      return;
    }
    var button = event.target.closest('[data-kcr-add]');
    if (!button) return;
    event.preventDefault();
    addToCart(button);
  }

  function isOwn(t) {
    return t.closest && (t.closest('.kirjala-gift-tiers') || t.closest('.kirjala-cart-recs-host') || t.closest('.kirjala-clear-cart'));
  }

  function initPage() {
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (isOwn(mutations[i].target)) continue;
        schedule();
        return;
      }
    });
    obs.observe(items, { childList: true, subtree: true });
    obs.observe(footer, { childList: true, subtree: true });
    items.addEventListener('click', onClick);
    footer.addEventListener('click', onClick);
    watchToast();
    ensurePage();
  }

  function init() {
    if (onPage()) {
      initPage();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function (mutations) {
      // Ohitetaan omat muutokset (viesti / suositukset), muuten seurataan korin uudelleenpiirtoa
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        if (t.closest && (t.closest('.kirjala-gift-tiers') || t.closest('.kirjala-cart-recs-host') || t.closest('.kirjala-clear-cart'))) continue;
        schedule();
        return;
      }
    }).observe(drawer, { childList: true, subtree: true });
    drawer.addEventListener('click', onClick);
    watchToast();
    ensure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
